import React, { useState } from "react";
import {
  TextField,
  MenuItem,
  Button,
  Grid,
  Typography,
  Card,
  CardContent,
  CircularProgress,
  Stepper,
  Step,
  StepLabel,
  Autocomplete,
  Switch,
} from "@mui/material";
import axios from "axios";
import debounce from "lodash.debounce";
import { useNavigate } from "react-router-dom";

const steps = [
  "Discount Details",
  "Pincode & Target",
  "Usage & Validity",
  "Collaborate Partner & status",
];

const PromoCodeForm = () => {
  const [activeStep, setActiveStep] = useState(0);
  const nagivate = useNavigate()
  const [formData, setFormData] = useState({
    variant: "coupon",
    code: "",
    discount_type: "discount",
    discount: "",
    max_discount_amount: "",
    fixedPrice: "",
    minimum_bill_amount: "",
    pincode_source: "all",
    pincodes: [],
    target_type: "all",
    target_users: [],
    number_of_uses: "",
    used_type: "once",
    valid_until: "",
    description: "",
    collabrate_partner: { entity_id: "", title: "", img_url: "" },
    is_live: true,
    is_public: false,
    is_prepaid:false
  });

  const [loading, setLoading] = useState(false);
  const [entityLoading, setEntityLoading] = useState(false);
  const [entities, setEntities] = useState([]);
  const [pincodes, setPincodes] = useState([]);
  const [pincodeLoading, setPincodeLoading] = useState(false);
  const [error, setError] = useState("");
  console.log(error)
  const [success, setSuccess] = useState("");
  const [users, setUsers] = useState([]);
  const [userLoading, setUserLoading] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  // Fetch entities with debounce
  const fetchEntities = debounce(async (searchTerm) => {
    if (!searchTerm) return;
    setEntityLoading(true);
    try {
      const response = await axios.get(
        `https://api.medstown.com/offer/entities/search?title=${searchTerm}`
      );
      setEntities(response.data.data);
    } catch (err) {
      console.error("Error fetching entities:", err);
    } finally {
      setEntityLoading(false);
    }
  }, 500);

  const fetchUsers = debounce(async (searchTerm) => {
    if (!searchTerm) return;
    setUserLoading(true);
    try {
      const response = await axios.get(
        `https://api.medstown.com/offer/user/search?slug=${searchTerm}`
      );
      setUsers(response.data.data);
    } catch (err) {
      console.error("Error fetching users:", err);
    } finally {
      setUserLoading(false);
    }
  }, 500);

  const fetchPincodes = debounce(async (searchTerm) => {
    if (!searchTerm) return;
    setPincodeLoading(true);
    try {
      const response = await axios.get(
        `https://api.medstown.com/offer/pincode?search=${searchTerm}`
      );
      setPincodes(response.data);
    } catch (err) {
      console.error("Error fetching pincodes:", err);
    } finally {
      setPincodeLoading(false);
    }
  }, 500);
  // validation

  // const validateStep = () => {
  //   if (activeStep === 0) {
  //     if (!formData.code) {
  //       setError("Promocode is required");
  //       return false;
  //     }
  //     if (formData.discount_type === "discount") {
  //       if (!formData.discount || !formData.max_discount_amount) {
  //         setError("Please provide discount and max discount amount");
  //         return false;
  //       }
  //     } else if (formData.discount_type === "fixedPrice") {
  //       if (!formData.fixedPrice) {
  //         setError("Please enter fixed price");
  //         return false;
  //       }
  //     }
  //   }

  //   if (activeStep === 2) {
  //     if (!formData.number_of_uses || !formData.minimum_bill_amount || !formData.valid_until || !formData.description) {
  //       setError("Please fill all required fields in this step");
  //       return false;
  //     }
  //   }

  //   // Step-specific validations can be extended as needed
  //   setError(""); // clear error if valid
  //   return true;
  // };

  const validateStep = () => {
    const errors = {};

    if (activeStep === 0) {
      if (!formData.code) {
        errors.code = "Promocode is required";
      }

      if (formData.discount_type === "discount") {
        if (!formData.discount) errors.discount = "Discount is required";
        if (!formData.max_discount_amount)
          errors.max_discount_amount = "Max discount amount is required";
      }

      if (formData.discount_type === "fixedPrice") {
        if (!formData.fixedPrice)
          errors.fixedPrice = "Fixed price discount is required";
      }
    }

    if (activeStep === 2) {
      if (!formData.number_of_uses)
        errors.number_of_uses = "Usage limit is required";
      if (!formData.minimum_bill_amount)
        errors.minimum_bill_amount = "Minimum bill amount is required";
      if (!formData.valid_until)
        errors.valid_until = "Valid until date is required";
      if (!formData.description)
        errors.description = "Description is required";
    }

    setFieldErrors(errors);

    return Object.keys(errors).length === 0;
  };





  const handleEntityChange = (_, selectedEntity) => {
    if (selectedEntity) {
      setFormData((prev) => ({
        ...prev,
        collabrate_partner: {
          entity_id: selectedEntity._id,
          title: selectedEntity.title,
          img_url: selectedEntity.img_url,
        },
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setFieldErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // const handleNext = () => {
  //   setActiveStep((prevStep) => prevStep + 1);
  // };
  const handleNext = () => {
    if (validateStep()) {
      setActiveStep((prevStep) => prevStep + 1);
    }
  };


  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleSubmit = async (e) => {
    console.log(formData, "formData");
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await axios.post(
        "https://api.medstown.com/offer/promocode",
        formData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status === 201) {
        setSuccess("Promocode created successfully!");
        setFormData({
          variant: "coupon",
          code: "",
          discount_type: "discount",
          discount: "",
          max_discount_amount: "",
          fixedPrice: "",
          minimum_bill_amount: "",
          pincode_source: "all",
          pincodes: [],
          target_type: "all",
          target_users: [],
          number_of_uses: "",
          used_type: "multiple",
          valid_until: "",
          description: "",
          collabrate_partner: { entity_id: "", title: "", img_url: "" },
        });
        setActiveStep(0);
        nagivate('/admin/coupons')
      }
    } catch (err) {
       console.error(err.response || err);
      setError(
        err.response?.data?.error_code ||
        "Failed to create promocode. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card sx={{ maxWidth: 900, margin: "auto", mt: 5, p: 3 }}>
      <CardContent>
        <Typography variant="h5" mb={3} gutterBottom>
          Create New Promocode
        </Typography>

        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <form>
          <Grid container spacing={2} sx={{ mt: 6 }}>
            {activeStep === 0 && (
              <>
                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    label="Promocode"
                    name="code"
                    value={formData.code}
                    onChange={handleChange}
                    error={Boolean(fieldErrors.code)}
                    helperText={fieldErrors.code}

                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    label="Discount Type"
                    name="discount_type"
                    value={formData.discount_type}
                    onChange={handleChange}
                    error={Boolean(fieldErrors.code)}
                    helperText={fieldErrors.code}
                  >
                    <MenuItem value="discount">Discount</MenuItem>
                    <MenuItem value="fixedPrice">Fixed Price</MenuItem>
                  </TextField>
                </Grid>

                {formData.discount_type === "discount" && (
                  <>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        type="number"
                        label="Discount (%)"
                        name="discount"
                        value={formData.discount}
                        onChange={handleChange}
                        error={Boolean(fieldErrors.code)}
                        helperText={fieldErrors.code}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        type="number"
                        label="Max Discount Amount"
                        name="max_discount_amount"
                        value={formData.max_discount_amount}
                        onChange={handleChange}
                        error={Boolean(fieldErrors.code)}
                        helperText={fieldErrors.code}
                      />
                    </Grid>
                  </>
                )}

                {formData.discount_type === "fixedPrice" && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      type="number"
                      label="Fixed Price Discount"
                      name="fixedPrice"
                      value={formData.fixedPrice}
                      onChange={handleChange}
                      error={Boolean(fieldErrors.code)}
                      helperText={fieldErrors.code}
                    />
                  </Grid>
                )}
              </>
            )}

            {activeStep === 1 && (
              <>
                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    label="Pincode Source"
                    name="pincode_source"
                    value={formData.pincode_source}
                    onChange={handleChange}
                    error={Boolean(fieldErrors.code)}
                    helperText={fieldErrors.code}
                  >
                    <MenuItem value="all">All</MenuItem>
                    <MenuItem value="specific">Specific</MenuItem>
                  </TextField>
                </Grid>
                {formData.pincode_source === "specific" && (
                  <Grid item xs={12}>
                    {/* <TextField
                      fullWidth
                      label="Enter Pincodes (comma separated)"
                      name="pincodes"
                      value={formData.pincodes.join(",")}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          pincodes: e.target.value
                            .split(",")
                            .map((pincode) => pincode.trim()),
                        })
                      }
                    /> */}
                    <Autocomplete
                      multiple
                      options={pincodes}
                      getOptionLabel={(option) => `${option.areaPincode} `} // Adjust this based on actual API response
                      onInputChange={(_, value) => fetchPincodes(value)}
                      onChange={(_, selectedPincodes) =>
                        setFormData((prev) => ({
                          ...prev,
                          pincodes: selectedPincodes.map(
                            (area) => area.areaPincode
                          ),
                        }))
                      }
                      loading={pincodeLoading}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Pincodes"
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {userLoading ? (
                                  <CircularProgress size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                          error={Boolean(fieldErrors.code)}
                          helperText={fieldErrors.code}
                        />
                      )}
                    />
                  </Grid>
                )}

                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    label="Target Type"
                    name="target_type"
                    value={formData.target_type}
                    onChange={handleChange}
                    error={Boolean(fieldErrors.code)}
                    helperText={fieldErrors.code}
                  >
                    <MenuItem value="all">All</MenuItem>
                    <MenuItem value="specific">Specific</MenuItem>
                  </TextField>
                </Grid>

                {formData.target_type === "specific" && (
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      options={users}
                      getOptionLabel={(option) =>
                        `${option.fullName} (${option.phone})`
                      } // Adjust this based on actual API response
                      onInputChange={(_, value) => fetchUsers(value)}
                      onChange={(_, selectedUsers) =>
                        setFormData((prev) => ({
                          ...prev,
                          target_users: selectedUsers.map((user) => user._id), // Store only user IDs
                        }))
                      }
                      loading={userLoading}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Users"
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {userLoading ? (
                                  <CircularProgress size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                      error={Boolean(fieldErrors.code)}
                      helperText={fieldErrors.code}
                    />
                  </Grid>
                )}
              </>
            )}

            {activeStep === 2 && (
              <>
                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    label="Used Type"
                    name="used_type"
                    value={formData.used_type}
                    onChange={handleChange}
                    error={Boolean(fieldErrors.code)}
                    helperText={fieldErrors.code}
                  >
                    <MenuItem value="once">Once's</MenuItem>
                    <MenuItem value="new_user">New Users</MenuItem>
                    <MenuItem value="multiple">Multiple</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Usage Limit"
                    name="number_of_uses"
                    type="number"
                    value={formData.number_of_uses}
                    onChange={handleChange}
                    // error={Boolean(fieldErrors.code)}
                    // helperText={fieldErrors.code}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Minimum Bill Amount"
                    name="minimum_bill_amount"
                    value={formData.minimum_bill_amount}
                    onChange={handleChange}
                    required
                    error={Boolean(fieldErrors.code)}
                    helperText={fieldErrors.code}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Valid Until"
                    name="valid_until"
                    InputLabelProps={{ shrink: true }}
                    value={formData.valid_until}
                    onChange={handleChange}
                    required
                    error={Boolean(fieldErrors.code)}
                    helperText={fieldErrors.code}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Description"
                    name="description"
                    multiline
                    rows={3}
                    value={formData.description}
                    onChange={handleChange}
                    required
                    error={Boolean(fieldErrors.code)}
                    helperText={fieldErrors.code}
                  />
                </Grid>
              </>
            )}

            {activeStep === 3 && (
              <>
                <Grid item xs={12}>
                  <Autocomplete
                    fullWidth
                    options={entities}
                    getOptionLabel={(option) => option.title}
                    onInputChange={(_, value) => fetchEntities(value)}
                    onChange={handleEntityChange}
                    loading={entityLoading}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Search Partner"
                        variant="outlined"
                        // error={Boolean(fieldErrors.code)}
                        // helperText={fieldErrors.code}
                      />
                    )}
                  />
                </Grid>
                {/* Publish Switch */}
                <Grid item xs={12} display="flex" alignItems="center">
                  <Typography variant="body1" sx={{ mr: 1 }}>
                    Publish
                  </Typography>
                  <Switch
                    name="Publish"
                    checked={formData.is_live}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        is_live: e.target.checked,
                      });
                    }}
                    color="default"
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "green",
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                      {
                        backgroundColor: "green",
                      },
                      "& .MuiSwitch-track": {
                        backgroundColor: "gray",
                      },
                    }}
                  />
                  <Typography variant="body1" sx={{ ml: 2, mr: 1 }}>
                    Show On App
                  </Typography>
                  <Switch
                    name="Keep Public"
                    checked={formData.is_public}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        is_public: e.target.checked,
                      });
                    }}
                    color="default"
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "green",
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                      {
                        backgroundColor: "green",
                      },
                      "& .MuiSwitch-track": {
                        backgroundColor: "gray",
                      },
                    }}
                  />
                    <Typography variant="body1" sx={{ ml: 2, mr: 1 }}>
                  Prepaid
                  </Typography>
                  <Switch
                    name="Keep Public"
                    checked={formData.is_prepaid}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        is_prepaid: e.target.checked,
                      });
                    }}
                    color="default"
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "green",
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                      {
                        backgroundColor: "green",
                      },
                      "& .MuiSwitch-track": {
                        backgroundColor: "gray",
                      },
                    }}
                  />
                </Grid>
              </>
            )}
          </Grid>

          <div style={{ marginTop: 20, marginBottom: 20 }}>
            <Button
              type="button"
              disabled={activeStep === 0}
              onClick={handleBack}
            >
              Back
            </Button>
            {activeStep === steps.length - 1 ? (
              <Button
                onClick={handleSubmit}
                variant="contained"
                color="primary"
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : "Submit"}
              </Button>
            ) : (
              <Button
                type="button"
                variant="contained"
                color="primary"
                onClick={handleNext}
              >
                Next
              </Button>
            )}
          </div>
        </form>

        {error && <Typography color="error">{error}</Typography>}
        {success && <Typography color="success">{success}</Typography>}
      </CardContent>
    </Card>
  );
};

export default PromoCodeForm;
